// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"90":"366ccb1a","678":"c854bc0d"}[chunkId] + ".chunk.css");